module.exports = __webpack_public_path__ + "img/ico-fb.7e3064cc.svg";